const orderPaths = {
  orders: '/order/orders',
  order: (number = ':number') => `/order/${number}`,
  orderFulfilments: '/order/fulfillments',
  clicks: '/order/clicks',
  batchUpdates: '/order/batch-updates',
  batchInitials: '/order/batch-updates/initials',
  batchUpsells: '/order/batch-updates/upsells',
  batchSubscriptions: '/order/batch-updates/subscriptions',
  subscription: (number = ':number') => `/order/batch-updates/subscriptions/${number}`,
  autoReruns: '/order/batch-updates/batch-results',
  transactions: '/order/transactions',
  testOrders: '/order/test-orders',
  batchReport: '/order/batch-updates/batch-report',
};

export default orderPaths;
